export const downloadCSV = (data, headers, keys, fileName = "download") => {
  if (!data || data.length === 0) {
    alert("No data available to download.");
    return;
  }

  const csvRows = [];
  
  // 1. Add header row
  csvRows.push(headers.join(",")); 

  // 2. Loop through data and map using the provided keys
  data.forEach((row) => {
    // Extract the values based on the 'keys' array passed to the function
    const values = keys.map(key => row[key]);

    // Escape quotes and wrap in quotes to prevent CSV breaks from internal commas
    const escapedValues = values.map((val) => {
      const stringVal = val === null || val === undefined ? "" : String(val);
      return `"${stringVal.replace(/"/g, '""')}"`;
    });

    csvRows.push(escapedValues.join(","));
  });

  // 3. Create and download the Blob
  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  // Use the dynamically passed filename
  link.setAttribute("download", `${fileName}.csv`);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};